import { render, staticRenderFns } from "./periodDialog.vue?vue&type=template&id=282f1415&scoped=true"
import script from "./periodDialog.vue?vue&type=script&lang=ts"
export * from "./periodDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f1415",
  null
  
)

export default component.exports